/**
 * PayPal Configuration Service
 *
 * Handles all PayPal configuration related API calls (admin only).
 */

import api from './api';
import type { ApiResponse } from '@budgira/shared';

/**
 * PayPal configuration interface.
 */
export interface PaypalConfig {
  singlePaymentPrice: number;
  monthlySubscriptionPrice: number;
  clientId: string | null;
  clientSecret: string | null;
  planId: string | null;
  webhookId: string | null;
  updatedAt: string;
}

/**
 * Update PayPal configuration request.
 */
export interface UpdatePaypalConfigRequest {
  singlePaymentPrice?: number;
  monthlySubscriptionPrice?: number;
  clientId?: string | null;
  clientSecret?: string | null;
  planId?: string | null;
  webhookId?: string | null;
}

export const paypalConfigService = {
  /**
   * Get the current PayPal configuration
   */
  async get(): Promise<ApiResponse<PaypalConfig>> {
    const response = await api.get<ApiResponse<PaypalConfig>>('/admin/paypal-config');
    return response.data;
  },

  /**
   * Update the PayPal configuration
   */
  async update(data: UpdatePaypalConfigRequest): Promise<ApiResponse<PaypalConfig>> {
    const response = await api.put<ApiResponse<PaypalConfig>>('/admin/paypal-config', data);
    return response.data;
  },
};

export default paypalConfigService;
